import * as signalR from "@microsoft/signalr";
import authService from "./authService";

const getApiBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  if (typeof window !== "undefined" && window.location) {
    return `${window.location.origin}/api`;
  }
  return "/api";
};

const HUB_URL = process.env.REACT_APP_HUB_URL || `${getApiBaseUrl()}/hubs/serverStats`;

let connection = null;
const callbacks = {
  onConnecting: [],
  onConnected: [],
  onDisconnected: [],
  onUpdateServerStatus: [],
};

const triggerCallbacks = (event, ...args) => {
  if (callbacks[event]) {
    callbacks[event].forEach((cb) => {
      try {
        cb(...args);
      } catch (err) {
        console.error(`Error in SignalR callback ${event}:`, err);
      }
    });
  }
};

const signalrService = {
  registerCallback(event, cb) {
    if (callbacks[event]) {
      callbacks[event].push(cb);
    }
    return () => {
      if (callbacks[event]) {
        callbacks[event] = callbacks[event].filter((c) => c !== cb);
      }
    };
  },

  start() {
    if (connection) return;

    connection = new signalR.HubConnectionBuilder()
      .withUrl(HUB_URL, {
        accessTokenFactory: () => authService.getToken(),
      })
      .withAutomaticReconnect()
      .build();

    connection.onreconnecting(() => {
      triggerCallbacks("onConnecting");
    });

    connection.onreconnected(() => {
      triggerCallbacks("onConnected");
    });

    connection.onclose(() => {
      triggerCallbacks("onDisconnected");
    });

    connection.on("UpdateServerStatus", (telemetry) => {
      triggerCallbacks("onUpdateServerStatus", telemetry);
    });

    triggerCallbacks("onConnecting");
    connection
      .start()
      .then(() => {
        triggerCallbacks("onConnected");
      })
      .catch((err) => {
        console.error("SignalR connection failed:", err);
        triggerCallbacks("onDisconnected");
      });
  },

  stop() {
    if (connection) {
      connection.stop();
      connection = null;
    }
  },

  isConnected() {
    return connection && connection.state === signalR.HubConnectionState.Connected;
  },
};

export default signalrService;
